import styled from "styled-components";

export const Container = styled.div`
    padding: 80px 0;
    text-align: center;
    max-width: 325px;
    margin: 0 auto;
    h3{
        font-size: 28px;
        line-height: 34px;
        font-weight: 900;
        color: #000;
        margin-bottom: 24px;
    }
    p{
        font-size: 16px;
        line-height: 24px;
        color: #000;
    }
`;
export const Icon = styled.img`
    width: 70px;
    margin-bottom: 30px;
    img{
        width: 70px;
    }
`;